import OnPremAgentClient from '~/api/OnPremAgentClient/OnPremAgentClient'
import useOnPremAgentQuery from '~/api/onPremAgent/useOnPremAgentQuery'
import StructuredDataForm, {
  StructuredDataFormData,
} from '~/components/StructuredDataForm/StructuredDataForm'
import { JsonSchema } from '~/types/JsonSchema.interface'
import cs from './generate_test_data_form.scss'

export default function GenerateTestDataForm({
  className,
  ingestorUuid,
  testDataParams,
  setTestDataParams,
}: {
  className?: string
  ingestorUuid: string
  testDataParams: StructuredDataFormData
  setTestDataParams: (values: StructuredDataFormData) => void
}) {
  let { loading, data: schema } = useOnPremAgentQuery<string, JsonSchema | undefined>({
    backendQueryParams: {
      apiQuery: async (client: OnPremAgentClient, ingestorUuid: string) =>
        ingestorUuid
          ? client.dataIngestors.getGenerateTestDataRequestSchema(ingestorUuid)
          : undefined,
      apiParams: ingestorUuid,
    },
  })

  const handleUpdate = (key: string, newValue: unknown) => {
    if (newValue === null) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [key]: _, ...paramsWithoutKey } = testDataParams ?? {}
      setTestDataParams(paramsWithoutKey)
    } else {
      setTestDataParams({ ...(testDataParams ?? {}), [key]: newValue })
    }
  }
  if (loading || schema == null) {
    return null
  }

  return (
    <div className={className}>
      <StructuredDataForm
        data={testDataParams}
        variant='wideValues'
        onEdit={handleUpdate}
        dataSchema={schema}
        className={cs.structuredDataForm}
      />
    </div>
  )
}
